module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_3.0f6d9c60.png";